import script from "./LoginOtp.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginOtp.vue?vue&type=script&setup=true&lang=js"

import "./LoginOtp.vue?vue&type=style&index=0&id=05dabba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05dabba4"]])

export default __exports__